import { useState } from 'react'
import clsx from 'clsx'
import { UserAvatarProps } from './userAvatar.types'
import { Image } from './userAvatar.styles'
import { getUserNameInitialLetters } from './utils'

const UserAvatar = ({ src, alt, small, className, onClick }: UserAvatarProps) => {
  const [error, setError] = useState(false)

  const name = alt?.trim()
  const showTextAvatar = !src || error

  if (showTextAvatar) {
    return (
      <Image
        as="div"
        title={name}
        small={Boolean(small)}
        className={clsx(
          '_bg-gray-200 _text-gray-700 _d-flex _justify-content-center _align-items-center _rounded-circle',
          className
        )}
        translate="no"
        data-component="user-avatar"
        onClick={onClick}
      >
        {getUserNameInitialLetters(name)}
      </Image>
    )
  }

  const handleError = ({ currentTarget }) => {
    currentTarget.onerror = null
    setError(true)
  }

  return (
    <Image
      src={src}
      alt={name}
      className={clsx('_bg-gray-200 _rounded-circle', className)}
      small={Boolean(small)}
      loading="lazy"
      data-component="user-avatar"
      onClick={onClick}
      onError={handleError}
    />
  )
}

export default UserAvatar
